export default __webpack_public_path__ + "static/8335-884e0b3fe9c51c734ef3dc1d2d26aa16.jpg";